import { Flex } from "rebass/styled-components";
import styled from "styled-components";

// Same card, icon, and button treatment as OutdatedMatchInterest, the
// other dialog on the match-history surface, so the two read as one set.
// No side margin: the Modal wrapper already caps width, and a margin
// here would push the shared close button off the card's corner.
export const DialogCard = styled(Flex)`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.modalBg};
  border: 1px solid ${({ theme }) => theme.colors.chalkAlpha10};
  border-radius: 20px;
  box-shadow: 0 0 30px ${({ theme }) => theme.colors.darkerNed};
  flex-direction: column;
  gap: 16px;
  max-width: 420px;
  padding: 40px 32px 32px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    padding: 32px 20px 24px;
  }
`;

export const IconContainer = styled(Flex)`
  align-items: center;
  background: ${({ theme }) => theme.colors.chalkAlpha10};
  border-radius: 16px;
  height: 64px;
  justify-content: center;
  width: 64px;
`;

export const PrimaryButton = styled.button`
  background: ${({ theme }) => theme.colors.envy};
  border: none;
  border-radius: 10px;
  color: white;
  cursor: pointer;
  font-family: Barlow;
  font-size: 15px;
  font-weight: 700;
  margin-top: 8px;
  padding: 12px 24px;
  transition: opacity 0.15s ease;
  width: 100%;

  &:hover {
    opacity: 0.9;
  }
`;

export const DismissButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.chalk};
  cursor: pointer;
  font-family: Barlow;
  font-size: 14px;
  font-weight: 500;
  padding: 4px;

  &:hover {
    color: ${({ theme }) => theme.colors.ice};
  }
`;
